<template>

    <div>
        <div class="container">

            <div class="card card-daily-challenge bg-white" style="height: calc(100vh - 190px);">
                <div class="card-header">
                    <div class="card-title flex">{{$t('menu_item_tutoring')}}</div>
                    <div class="card-desc-right">
                        <div class="select-wrapper" style="display: inline-block;">
                            <select name="tutoring_filter" id="tutoring_filter" v-model="tutoring_filter" @change="filterTutoring" class="form-control" placeholder = "Filter">
                                <option value="">{{$t('all')}}</option>
                                <option value="registered">{{$t('registered')}}</option>
                                <option value="unregistered">{{$t('unregistered')}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="card-body" style="max-height: 100%; overflow: hidden;margin-bottom: 20px;">

                    <div class="d-flex">
                        <div class="flex">{{$t('tutoring_desc')}}</div>
                        <div>
                            <img src="/themes/web/assets/images/icon-tutoring-help.svg" data-bs-toggle="modal" data-bs-target="#tutoringHelpModal" alt="">
                        </div>
                    </div>

                    <div class="tutoring">
                        <div class="tutoring-left">
                            <div class="title">{{$t('recent_class')}}</div>

                            <div class="nano" style="height: 100%;">
                                <div class="nano-content">
                                    <div class="tutoring-items">

                                        <template v-for="(tutoring, index) in tutorings">
                                            <tutoring-item :tutoring="tutoring" @updateTutoring = "updateTutoring" v-if="showTutoringItem(tutoring)" />
                                        </template>                                        

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="tutoring-right">
                            <div class="tutoring-calander">
                                <div class="tutoring-calander-header">
                                    <div class="title">
                                        {{month_label}}, {{year}}
                                    </div>
                                    <div class="tools">
                                        <a href="#" style="margin-right: 20px;" @click="prevDay"><i class="lisa-icon-calander-prev"></i></a>
                                        <a href="#" @click="nextDay"><i class="lisa-icon-calander-next"></i></a>
                                    </div>
                                </div>
                                <div class="tutoring-calander-body">
                                    <div class="tutoring-calander-row tutoring-calander-row-header">
                                        <div class="tutoring-calander-item">{{$t('mo')}}</div>
                                        <div class="tutoring-calander-item">{{$t('tu')}}</div>
                                        <div class="tutoring-calander-item">{{$t('we')}}</div>
                                        <div class="tutoring-calander-item">{{$t('th')}}</div>
                                        <div class="tutoring-calander-item">{{$t('fr')}}</div>
                                        <div class="tutoring-calander-item">{{$t('sa')}}</div>
                                        <div class="tutoring-calander-item">{{$t('su')}}</div>
                                    </div>

                                    <div class="tutoring-calander-row" v-for="(calander, index) in calanders">
                                        <template v-for="(day, index) in calander">
                                            <div class="tutoring-calander-item" v-if="day.day == ''"></div>
                                            <div class="tutoring-calander-item active" v-else-if="day.current == true">{{day.day}}</div>
                                            <div class="tutoring-calander-item disabled" v-else-if="day.disabled == true">{{day.day}}</div>
                                            <div class="tutoring-calander-item" v-else="day.day != ''">
                                                {{day.day}}

                                                <span class="tutoring-calander-dot-3" v-if="day.subject == 'math'"></span>
                                                <span class="tutoring-calander-dot-2" v-else-if="day.subject == 'science'"></span>
                                                <span class="tutoring-calander-dot-1" v-else-if="day.subject == 'ge'"></span>
                                                <span class="tutoring-calander-dot-1" v-else-if="day.subject == 'igs'"></span>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal fade modal-flex" id="dailyBonusModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="dailyBonusModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 539px; max-width: 539px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">{{$t('daily_bonus')}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="daily-bonus">
                                <div class="daily-bonus-gem">
                                    <div class="text-1">DAY 1</div>
                                    <div class="gem">
                                        <i class="lisa-icon-gem-large"></i>
                                    </div>
                                    <div class="text-2">+30</div>
                                </div>
                                <div class="daily-bonus-content">
                                    {{$t('daily_bonus_msg')}}
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-main-border m-auto" style="padding: 8px 15px;">{{$t('claim')}}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade modal-flex" id="claimSuccessModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 365px; max-width: 365px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">{{$t('congratulations')}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="welcome-back">
                                <img src="/themes/web/assets/images/modal-image-success.svg" alt="" />
                                <div class="welcome-back-content">
                                    <span class="modal-title" style="vertical-align: bottom;">+1,200</span> <i class="lisa-icon-gem-large-2" style="vertical-align: middle;"></i>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-main-sm m-auto" style="padding: 8px 40px;">OK</button>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="modal fade modal-flex" id="tutoringHelpModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 207px; max-width: 207px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title">{{$t('colour_explanation')}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="tutoring-help-modal">
                                <p><span class="c1"></span> {{$t('live_now_classes')}}</p>
                                <p><span class="c2"></span> {{$t('registered_classes')}}</p>
                                <p><span class="c3"></span> {{$t('not_register_classes')}}</p>
                                <p><span class="c4"></span> {{$t('full_slots')}}</p>
                                <p><span class="c5"></span> {{$t('finished_classes')}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade modal-flex" id="tutoringDetailRegisterSuccessModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 365px; max-width: 365px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title">{{$t('registered_successfully')}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="welcome-back">
                                <img src="/themes/web/assets/images/modal-image-success.svg" alt="" />

                                <div class="welcome-back-content" v-if="tutoring_result">
                                    {{$t('dont_forget_the_class_at')}} {{tutoring_result.time_start | convertUnitToTime('HH:mm, DD MMM, YYYY')}}.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
import axios from "axios";
import { getTutorings } from "../../models/tutoring";
import TutoringItem from "./TutoringItem";
import {convertSecondToText} from "../../utils/utils";

export default {
    name: "Tutoring",
    title: "Tutoring",
    components: { TutoringItem },

    data() {
        const date = new Date();
        const year = date.getFullYear();
        const months = [
            this.$i18n.t('month_1'),
            this.$i18n.t('month_2'),
            this.$i18n.t('month_3'),
            this.$i18n.t('month_4'),
            this.$i18n.t('month_5'),
            this.$i18n.t('month_6'),
            this.$i18n.t('month_7'),
            this.$i18n.t('month_8'),
            this.$i18n.t('month_9'),
            this.$i18n.t('month_10'),
            this.$i18n.t('month_11'),
            this.$i18n.t('month_12')
        ];
        const month = date.getMonth() + 1;
        const month_label = months[month - 1];
        const calanders = this.getCalanders(month, year);

        return {
            tutorings: [],
            year: year,
            months: months,
            month: month,
            month_label: month_label,
            calanders: calanders,
            subscribe_days: [],
            subscribe_from: '',
            tutoring_filter: '',
            tutoring_result: null,
        };
    },

    computed: {
        user_info() {
            return this.$store.state.user_info;
        },
    },

    created() {
        this.$store.commit("setMenuActive", "tutoring");

        this.fetch();
    },

    methods: {
        async getListTutoring(month, year){
            const that = this;

            await axios.all([getTutorings({
                month: that.month,
                year: that.year
            })]).then(
                axios.spread((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        that.tutorings = [];

                        return;
                    }

                    try {
                        that.tutorings = response.data.results?response.data.results.class : [];
                    } catch (error) {
                        console.error(error);
                    }

                    that.tutorings.forEach(function(tutoring) {
                        //tutoring.status = 3;
                    })

                    that.calanders.forEach(function(calander) {
                        calander.forEach(function(day) {
                            if (day.disabled == false) {
                                day.subject = that.getSubject(day.day)
                            }
                        })
                    })

                    that.$nextTick(function() {
                        // initNanoScroller();
                    });
                })
            );
        },

        fetch() {
            this.getListTutoring(this.month, this.year);
        },

        showTutoringItem(tutoring){
            if(this.tutoring_filter == ''){
                return true;
            }

            if(this.tutoring_filter == 'registered' && tutoring.status == 1){
                return true;
            } 
            
            if(this.tutoring_filter == 'unregistered' && tutoring.status != 1){
                return true;
            }

            return false;
        },

        updateTutoring(action, tutoring, response){
            tutoring.status = response.status;

            this.subscribe_from = tutoring.subscribe_from;

            this.tutoring_result = tutoring;

            if(action == 'subscribe'){
                $('#tutoringDetailRegisterSuccessModal').modal('show');
            }
        },

        filterTutoring(e){
            console.log(e.target.value)
        },

        convertUnitToTime(time, format = 'DD MMM, YYYY HH:mm:ss') {
            if (time) {
                return moment.unix(time).format(format)
            }

            return '';
        },

        prevDay(e) {
            const that = this;

            this.$store.commit("setLoading", true);

            if (this.month == 1) {
                this.month = 12;
                this.year = this.year - 1;
            } else {
                this.month = this.month - 1;
            }
            this.month_label = this.months[this.month - 1];

            this.calanders = this.getCalanders(this.month, this.year);

            this.getListTutoring(this.month, this.year);

            e.preventDefault();
        },
        nextDay(e) {
            const that = this;

            this.$store.commit("setLoading", true);

            if (this.month == 12) {
                this.month = 1;
                this.year = this.year + 1;
            } else {
                this.month = this.month + 1;
            }
            this.month_label = this.months[this.month - 1];

            this.calanders = this.getCalanders(this.month, this.year);

            this.getListTutoring(this.month, this.year);

            e.preventDefault();
        },

        chunks(array, size) {
            var results = [];
            while (array.length) {
                results.push(array.splice(0, size));
            }
            return results;
        },

        getCalanders(month, year) {
            const that = this;
            const date = new Date();
            const data = [];
            const firstDay = this.getFirstDayInMonth(month, year);
            const lastDay = this.getDaysInMonth(month, year);
            const days = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
            const current_date = date.getDate();
            const current_month = date.getMonth() + 1;
            const current_year = date.getFullYear();

            const lastDayMonthBefore = this.getDaysInMonth(month - 1, year);
            for (var i = firstDay - 1; i >= 1; i--) {
                data.push({
                    day: lastDayMonthBefore - i,
                    disabled: true
                });
            }

            for (var i = 1; i <= lastDay; i++) {
                let disabled = false;
                let current = false;

                if (current_year < year || (current_year == year && current_month < month) || (current_year == year && current_month == month && current_date < i)) {
                    //disabled = true;
                }

                if (current_year == year && current_month == month && current_date == i) {
                    current = true;
                }

                const d = new Date(year, month - 1, i).getDay();
                data.push({
                    day: i,
                    label: days[d - 1],
                    disabled: disabled,
                    current: current,
                });
            }

            const lastDays = Math.ceil(data.length / 7) * 7 - data.length;
            for (var i = 1; i <= lastDays; i++) {
                data.push({
                    day: i,
                    disabled: true
                });
            }

            return this.chunks(data, 7);
        },

        getSubject(day) {
            const that = this;
            let subject = "";

            that.tutorings.forEach(function(tutoring) {
                const s_day = that.convertUnitToTime(tutoring.subscribe_from, 'DD');
                if (s_day == day) {
                    subject = tutoring.subject;
                }
            });

            return subject;
        },

        getDaysInMonth(month, year) {
            // Here January is 1 based
            // Day 0 is the last day in the previous month
            return new Date(year, month, 0).getDate();
            // Here January is 0 based
            // return new Date(year, month+1, 0).getDate();
        },

        getFirstDayInMonth(month, year) {
            return new Date(year, month - 1, 1).getDay();
        },
    },
};
</script>

<style scoped>
    /* .container{
        width: 940px;
        padding: 0;
    } */
</style>
